import { InventorySystemTypes } from '../../types'
import type { InventorySystemTypeSelectProps } from './InventorySystemTypeSelect.types'
import { compareSelectLabels } from '../../helpers/compareSelectLabels'

const options = [...Object.values(InventorySystemTypes)].sort(
  compareSelectLabels
)

export function InventorySystemTypeSelect({
  value,
  onChange,
}: InventorySystemTypeSelectProps) {
  return (
    <select
      className="form-select form-select-sm"
      aria-label="Inventory system type"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Select…</option>
      {options.map((type) => (
        <option key={type} value={type}>
          {type}
        </option>
      ))}
    </select>
  )
}
